import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { FeatureFlagService } from "../shared/services/feature-flag.service";
import { AllBonListComponent } from "../modules/shared/bon/all-bon-list/all-bon-list.component";

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsGuard {

  constructor(
    private readonly featureFlagService : FeatureFlagService,
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    switch (route.routeConfig.component) {
      case AllBonListComponent :
        return this.featureFlagService.isPreviewEnabled();
    }
   return false;
  }

}
